"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.greaterOrEqualTo = exports.greaterThan = exports.lessOrEqualTo = exports.lessThan = exports.equals = exports.valueAs = exports.getText = exports.getInteger = exports.getAmount = exports.fromText = exports.fromInteger = exports.fromAmount = exports.create = void 0;
exports.fromString = fromString;
const uom_1 = require("@genesys/uom");
const property_1 = require("@promaster-sdk/property");
const PropertyCompare = __importStar(require("./property-compare"));
var property_value_1 = require("@promaster-sdk/property/lib/property-value");
Object.defineProperty(exports, "create", { enumerable: true, get: function () { return property_value_1.create; } });
Object.defineProperty(exports, "fromAmount", { enumerable: true, get: function () { return property_value_1.fromAmount; } });
Object.defineProperty(exports, "fromInteger", { enumerable: true, get: function () { return property_value_1.fromInteger; } });
Object.defineProperty(exports, "fromText", { enumerable: true, get: function () { return property_value_1.fromText; } });
Object.defineProperty(exports, "getAmount", { enumerable: true, get: function () { return property_value_1.getAmount; } });
Object.defineProperty(exports, "getInteger", { enumerable: true, get: function () { return property_value_1.getInteger; } });
Object.defineProperty(exports, "getText", { enumerable: true, get: function () { return property_value_1.getText; } });
Object.defineProperty(exports, "toString", { enumerable: true, get: function () { return property_value_1.toString; } });
Object.defineProperty(exports, "valueAs", { enumerable: true, get: function () { return property_value_1.valueAs; } });
const equals = (left, right) => property_1.PropertyValue.equals(left, right, PropertyCompare.compare);
exports.equals = equals;
const lessThan = (left, right) => property_1.PropertyValue.lessThan(left, right, PropertyCompare.compare);
exports.lessThan = lessThan;
const lessOrEqualTo = (left, right) => property_1.PropertyValue.lessOrEqualTo(left, right, PropertyCompare.compare);
exports.lessOrEqualTo = lessOrEqualTo;
const greaterThan = (left, right) => property_1.PropertyValue.greaterThan(left, right, PropertyCompare.compare);
exports.greaterThan = greaterThan;
const greaterOrEqualTo = (left, right) => property_1.PropertyValue.greaterOrEqualTo(left, right, PropertyCompare.compare);
exports.greaterOrEqualTo = greaterOrEqualTo;
function fromString(encodedValue) {
    return property_1.PropertyValue.fromString(encodedValue.toLowerCase(), uom_1.unitLookup);
}
//# sourceMappingURL=property-value.js.map